const dimensions = [
    "Helhetsintryck",
    "Emotionellt stöd",
    "Delaktighet och involvering",
    "Respekt och bemötande",
    "Kontinuitet och koordinering",
    "Information och kunskap",
    "Vård och behandling",
    "Delaktighet",
    "Bemötande",
    "Kontinuitet",
    "Information",
    "Tillgänglighet",
    "Trygghet och säkerhet",
    "Levnadsvanor",
    "Nationella läkemedelslistan",
    "Om patienten",
    "Funktionshinder",
    "Coronarelaterade frågor",
    "Barn och ungdom",
    "Barn 8-14 år",
    "Övrigt",
    "Övriga frågor",
    "Regionala extrafrågor",
    "Dold",
    "Öppet",
    "Öppet barn",
] as const;

const dimensionSet = new Set<string>(dimensions);

export type DimensionValue = (typeof dimensions)[number];

export interface Dimension {
    value: DimensionValue;
    description?: string;
    icon?: string;
    isBase: boolean;
    isFreeText: boolean;
    hideInPublic: boolean;
}

export function isDimensionValue(value: string): value is DimensionValue {
    return dimensionSet.has(value);
}
